import angular, { IDirective } from 'angular';

export function Spaceless(): IDirective {
    const containsSomething = /S/;
    return {
        transclude: true,
        link: function (scope, el, attr, controller, transclude) {
            transclude && transclude(scope, function (clone) {
                //find text nodes that are just white space and kill them
                angular.forEach(clone, function (child) {
                    if (
                        child.nodeType === 3 &&
                        !containsSomething.test(child.textContent)
                    ) {
                        return;
                    }
                    el.append(child);
                });
            });
        },
    };
}
